export type CheckpointCelebrationVideo = {
  src: string;
  phrase: string;
  translation: string;
};

/**
 * Shared Learn with Locals celebration clips, keyed by target locale.
 * Learn end-of-session and Quick Review checkpoints cycle through the same pool.
 */
const CELEBRATION_VIDEOS: Record<string, CheckpointCelebrationVideo[]> = {
  fr: [
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/IAV_ALX22FR03_LIONEL001_86664_0f2fa540__86664__m.mp4',
      phrase: 'Félicitations!',
      translation: 'Congratulations!',
    },
    {
      src: 'https://static.memrise.com/uploads/things/video/medium/1000093899_161028_1558_27.mp4',
      phrase: 'Bien joué!',
      translation: 'Well done!',
    },
    {
      src: 'https://static.memrise.com/uploads/things/video/medium/1000093899_161122_1456_57_normalized.mp4',
      phrase: 'Bien joué!',
      translation: 'Well done!',
    },
    {
      src: 'https://static.memrise.com/uploads/things/video/medium/1000093899_161122_1457_38.mp4',
      phrase: 'Bien joué!',
      translation: 'Well done!',
    },
    {
      src: 'https://static.memrise.com/uploads/things/video/medium/1000091265_170217_1459_12_normalized.mp4',
      phrase: 'Génial',
      translation: 'Awesome',
    },
    {
      src: 'https://static.memrise.com/uploads/babylon/4/videos/trop+bien+%21/medium/1.mp4',
      phrase: 'Trop bien!',
      translation: 'Awesome!',
    },
  ],
  de: [
    {
      src: 'https://static.memrise.com/uploads/things/video/medium/1000080155_161025_1517_49.mp4',
      phrase: 'Gut gemacht!',
      translation: 'Well done!',
    },
    {
      src: 'https://static.memrise.com/uploads/things/video/medium/1000077953_161025_1515_46.mp4',
      phrase: 'Gratulation!',
      translation: 'Congratulations!',
    },
    {
      src: 'https://static.memrise.com/uploads/things/video/medium/1000077953_161025_1515_55.mp4',
      phrase: 'Gratulation!',
      translation: 'Congratulations!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/IAV_ALX22DE03_LENA0959_118358_9d448d0a__118358__f_normalized.mp4',
      phrase: 'Herzlichen Glückwunsch!',
      translation: 'Congratulations!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/IAV2023_DE_CHRIS_11886_83581fb8__11886__m_normalized.mp4',
      phrase: 'Super',
      translation: 'Awesome',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/IAV2023_DE_MARIA_11886_c0225772__11886__f.mp4',
      phrase: 'Super',
      translation: 'Awesome',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/IAV_ALX22_DE01_TIMOTHYFX30152_116364_55b5b80e__116364__m.mp4',
      phrase: 'Wahnsinn!',
      translation: 'Awesome!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/IAV_ALX22DE01_Maria593_116364_499ee6b9__116364__f_normalized.mp4',
      phrase: 'Wahnsinn!',
      translation: 'Awesome!',
    },
  ],
  es: [
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/95728__f__1534742326.mp4',
      phrase: '¡Enhorabuena!',
      translation: 'Congratulations!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/95728__f__1534925836.mp4',
      phrase: 'Enhorabuena',
      translation: 'Congratulations',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/95728__f__1534355211.mp4',
      phrase: 'Enhorabuena',
      translation: 'Congratulations',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/95728__m__1534916328.mp4',
      phrase: 'Enhorabuena',
      translation: 'Congratulations',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/95728__m__1534312714.mp4',
      phrase: 'Enhorabuena',
      translation: 'Congratulations',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/95728__m__1534917694.mp4',
      phrase: 'Enhorabuena',
      translation: 'Congratulations',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/95728__f__1535096395.mp4',
      phrase: 'Enhorabuena',
      translation: 'Congratulations',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/IAV_AGS_ES_BEA_120313_b16dcae6.mp4',
      phrase: 'Te felicito',
      translation: 'Congratulations',
    },
    {
      src: 'https://static.memrise.com/uploads/babylon/2/videos/%C2%A1enhorabuena%21/medium/1.mp4',
      phrase: '¡Enhorabuena!',
      translation: 'Congratulations!',
    },
    {
      src: 'https://static.memrise.com/uploads/things/video/medium/1000039847_170201_1438_07.mp4',
      phrase: '¡Enhorabuena!',
      translation: 'Congratulations!',
    },
    {
      src: 'https://static.memrise.com/uploads/things/video/medium/1000039847_170201_1438_16.mp4',
      phrase: '¡Enhorabuena!',
      translation: 'Congratulations!',
    },
    {
      src: 'https://static.memrise.com/uploads/babylon/2/videos/%C2%A1bien+hecho%21/medium/1.mp4',
      phrase: '¡Bien hecho!',
      translation: 'Well done!',
    },
    {
      src: 'https://static.memrise.com/uploads/babylon/2/videos/%C2%A1bien+hecho%21/medium/2.mp4',
      phrase: '¡Bien hecho!',
      translation: 'Well done!',
    },
    {
      src: 'https://static.memrise.com/uploads/things/video/medium/1000041982_170201_1236_34.mp4',
      phrase: '¡Bien hecho!',
      translation: 'Well done!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/IAV_ALX22ES05_GRACIA_121204_2386c07c_normalized.mp4',
      phrase: '¡Buen trabajo!',
      translation: 'Good job!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/IAV_ALX22ES05_PEDRO_121204_c27e3950.mp4',
      phrase: '¡Buen trabajo!',
      translation: 'Good job!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/95685__f__1534423918.mp4',
      phrase: '¡Estupendo!',
      translation: 'Excellent!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/95685__m__1534495505.mp4',
      phrase: '¡Estupendo!',
      translation: 'Excellent!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/95685__m__1534496031.mp4',
      phrase: '¡Estupendo!',
      translation: 'Excellent!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/95685__f__1534220085.mp4',
      phrase: '¡Estupendo!',
      translation: 'Excellent!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/95685__m__1534248195.mp4',
      phrase: '¡Estupendo!',
      translation: 'Excellent!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/95685__m__1534916259.mp4',
      phrase: '¡Estupendo!',
      translation: 'Excellent!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/20010LWLA_ES_CARD01_C025_01_MP4_bc19006b__114577__u.mp4',
      phrase: 'Genial',
      translation: 'Awesome',
    },
  ],
  'es-mx': [
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/IAV_ALX22ES03_JUAN_118016_877a4054__118016__m.mp4',
      phrase: '¡Felicitaciones!',
      translation: 'Congratulations!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/AV_ALX22MX01_JUAN_710_5e0d4ae6__118237__m.mp4',
      phrase: '¡Sigue así!',
      translation: 'Keep it up!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/IAV_ALX22MX01_ALE5E23_118237_2_c9b59857__118237__f_normalized.mp4',
      phrase: '¡Sigue así!',
      translation: 'Keep it up!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/IAV_ALX22MX01_ALE5E23_118237_714f6725__118237__f_normalized.mp4',
      phrase: '¡Sigue así!',
      translation: 'Keep it up!',
    },
  ],
  it: [
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/93354__f__1534350211_normalized.mp4',
      phrase: 'Congratulazioni!',
      translation: 'Congratulations!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/93354__f__1533831968_normalized.mp4',
      phrase: 'Congratulazioni!',
      translation: 'Congratulations!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/93354__f__1533915150.mp4',
      phrase: 'Congratulazioni!',
      translation: 'Congratulations!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/93354__m__1533912231_normalized.mp4',
      phrase: 'Congratulazioni!',
      translation: 'Congratulations!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/93354__m__1533914973_normalized.mp4',
      phrase: 'Congratulazioni!',
      translation: 'Congratulations!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/93354__m__1534350240_normalized.mp4',
      phrase: 'Congratulazioni!',
      translation: 'Congratulations!',
    },
    {
      src: 'https://static.memrise.com/uploads/things/video/medium/1000108253_170221_1415_17.mp4',
      phrase: 'Congratulazioni!',
      translation: 'Congratulations!',
    },
    {
      src: 'https://static.memrise.com/uploads/things/video/medium/1000108253_170221_1415_32.mp4',
      phrase: 'Congratulazioni!',
      translation: 'Congratulations!',
    },
    {
      src: 'https://static.memrise.com/uploads/babylon/6/videos/ben+fatto%21/medium/1.mp4',
      phrase: 'Ben fatto!',
      translation: 'Well done!',
    },
    {
      src: 'https://static.memrise.com/uploads/babylon/6/videos/ben+fatto%21/medium/2.mp4',
      phrase: 'Ben fatto!',
      translation: 'Well done!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/IAV2023_IT_GAETANO_17566_8e27243f__17566__m.mp4',
      phrase: 'Splendido',
      translation: 'Awesome',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/IAV2023_IT_JESSICA_17566_9909b214__17566__f.mp4',
      phrase: 'Splendido',
      translation: 'Awesome',
    },
  ],
  tr: [
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/IAV_LWLQ42024_TR_FATMA_F_33185_0ab30019__33185__f_normalized.mp4',
      phrase: 'Tebrikler!',
      translation: 'Congratulations!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/IAV_LWLQ42024_TR_FATMA_F_33040_4754aac4__33040__f_normalized.mp4',
      phrase: 'Bu çok iyi!',
      translation: "It's very good!",
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/IAV_LWLQ32025_TR_YUSUF_M_34451_0d21bec5__34451__m_normalized.mp4',
      phrase: 'İyi maçtı ama!',
      translation: 'Well played!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/IAV_LWLQ32025_TR_HANDE_F_35532_1edfdfac__35532__f_normalized.mp4',
      phrase: 'Harikasın!',
      translation: "You're awesome!",
    },
  ],
  pt: [
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/1000113948_170227_2237_45_cd2a3473__115463__m.mp4',
      phrase: 'Parabéns!',
      translation: 'Congratulations!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/2%20%283%29_f7dde189__115463__m.mp4',
      phrase: 'Parabéns!',
      translation: 'Congratulations!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/1%20%284%29_17295b52__115463__f.mp4',
      phrase: 'Parabéns!',
      translation: 'Congratulations!',
    },
    {
      src: 'https://static.memrise.com/uploads/babylon/15/videos/muito+bem%21/medium/1.mp4',
      phrase: 'Muito bem!',
      translation: 'Well done!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/IAV_ALX22_PT01_GIL219_25130_642b4d8e__25130__m_normalized.mp4',
      phrase: 'Excelente',
      translation: 'Excellent',
    },
  ],
  'pt-br': [
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/IAV_LWLQ42024_BR_TAMIRES_F_27168_601ad688__27168__f.mp4',
      phrase: 'Parabéns!',
      translation: 'Congratulations!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/IAV_LWLQ42024_BR_TAMIRES_F_27026_e39829c3__27026__f.mp4',
      phrase: 'Isso é muito bom!',
      translation: "It's very good!",
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/IAV_LWLQ32025_BR_ALYNE_F_28448_f0fca532__28448__f_normalized.mp4',
      phrase: 'Bem jogado!',
      translation: 'Well played!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/IAV_LWLQ42024_BR_ADRIANO_M_26822_5b60d586__26822__m.mp4',
      phrase: 'Você fala português muito bem!',
      translation: 'You speak Portuguese very well!',
    },
  ],
  nl: [
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/IAV_LWLQ42024_NL_REMON_M_21077_faa59f2c__21077__m.mp4',
      phrase: 'Gefeliciteerd!',
      translation: 'Congratulations!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/IAV_LWLQ42024_NL_REMON_M_20906_f124a5fb__20906__m_normalized.mp4',
      phrase: 'Het is erg goed!',
      translation: "It's very good!",
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/IAV_LWLQ42024_NL_KIRSTEN_F_20626_eb10a489__20626__f_normalized.mp4',
      phrase: 'Dat is geweldig!',
      translation: "That's great!",
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/IAV_LWLQ42024_NL_REMON_M_20487_a502709e__20487__m.mp4',
      phrase: 'Geweldig!',
      translation: 'Awesome!',
    },
  ],
  sv: [
    {
      src: 'https://static.memrise.com/uploads/things/video/medium/1000133845_170219_1357_01.mp4',
      phrase: 'Grattis!',
      translation: 'Congratulations!',
    },
    {
      src: 'https://static.memrise.com/uploads/things/video/medium/1000133845_170219_1357_13.mp4',
      phrase: 'Grattis!',
      translation: 'Congratulations!',
    },
    {
      src: 'https://static.memrise.com/uploads/things/video/medium/1000135995_170223_1101_37.mp4',
      phrase: 'Bra gjort!',
      translation: 'Well done!',
    },
    {
      src: 'https://static.memrise.com/uploads/things/video/medium/1000133473_170219_1224_28.mp4',
      phrase: 'Det är jättebra!',
      translation: "That's great!",
    },
    {
      src: 'https://static.memrise.com/uploads/things/video/medium/1000133473_170219_1224_41.mp4',
      phrase: 'Det är jättebra!',
      translation: "That's great!",
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/IAV_LWLQ32025_SV_ANNI_F_44351_43b550d3__44351__f.mp4',
      phrase: 'Jättebra!',
      translation: 'Excellent!',
    },
    {
      src: 'https://static.memrise.com/uploads/things/video/medium/1000135080_170221_1255_31.mp4',
      phrase: 'Bra spelat!',
      translation: 'Well played!',
    },
  ],
  no: [
    {
      src: 'https://static.memrise.com/uploads/things/video/medium/1000136588_170216_1724_32.mp4',
      phrase: 'Gratulerer!',
      translation: 'Congratulations!',
    },
    {
      src: 'https://static.memrise.com/uploads/things/video/medium/1000136588_170216_1724_09.mp4',
      phrase: 'Gratulerer!',
      translation: 'Congratulations!',
    },
    {
      src: 'https://static.memrise.com/uploads/things/video/medium/1000136959_170217_1210_29.mp4',
      phrase: 'Fett!',
      translation: 'Awesome!',
    },
    {
      src: 'https://static.memrise.com/uploads/things/video/medium/1000136959_170217_1210_41.mp4',
      phrase: 'Fett!',
      translation: 'Awesome!',
    },
    {
      src: 'https://static.memrise.com/uploads/things/video/medium/1000136221_170216_1350_34.mp4',
      phrase: 'Det er kjempebra!',
      translation: "That's great!",
    },
  ],
  pl: [
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/IAV_Q42024_PL_Natalia_F_64937_2dd8a997__64937__f_normalized.mp4',
      phrase: 'Moje gratulacje!',
      translation: 'My congratulations!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/IAV_Q42024_PL_Natalia_F_64381_380f43e9__64381__f_normalized.mp4',
      phrase: 'To świetnie!',
      translation: "That's great!",
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/IAV_LWLQ32025_PL_WIKTORIA_F_64163_3becf2cb__64163__f.mp4',
      phrase: 'Fantastyczny!',
      translation: 'Fantastic!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/IAV_Q42024_PL_Natalia_F_64457_1c2fdda0__64457__f_normalized.mp4',
      phrase: 'Bardzo dobrze mówisz po polsku!',
      translation: 'You speak Polish very well!',
    },
  ],
  da: [
    {
      src: 'https://static.memrise.com/uploads/things/video/medium/1000127571_170202_1438_05.mp4',
      phrase: 'Tillykke!',
      translation: 'Congratulations!',
    },
    {
      src: 'https://static.memrise.com/uploads/things/video/medium/1000127571_170202_1437_47_normalized.mp4',
      phrase: 'Tillykke!',
      translation: 'Congratulations!',
    },
    {
      src: 'https://static.memrise.com/uploads/things/video/medium/1000129766_170203_1601_08.mp4',
      phrase: 'Godt gået!',
      translation: 'Well done!',
    },
    {
      src: 'https://static.memrise.com/uploads/things/video/medium/1000129766_170203_1601_54.mp4',
      phrase: 'Godt gået!',
      translation: 'Well done!',
    },
  ],
  is: [
    {
      src: 'https://static.memrise.com/uploads/things/video/158210022_170920_1527_18.mp4',
      phrase: 'Mjög gott!',
      translation: 'Very good!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/IAV_LWLQ32025_IS_FLEMMING_M_289705_d5532ff6__289705__m_normalized.mp4',
      phrase: 'Geggjað',
      translation: 'Awesome',
    },
    {
      src: 'https://static.memrise.com/uploads/things/video/158210022_170920_1527_14.mp4',
      phrase: 'Mjög gott',
      translation: 'Very well',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/IAV_LWLQ32024_IS_FLEMMING_F_250263_8b06bb84__250263__f_normalized.mp4',
      phrase: 'Það er frábært!',
      translation: "That's great!",
    },
  ],
  sl: [
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/98554__f__1537517598.mp4',
      phrase: 'Čestitam!',
      translation: 'Congratulations!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/98554__f__1537487116.mp4',
      phrase: 'Čestitam!',
      translation: 'Congratulations!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/98554__m__1537516181.mp4',
      phrase: 'Čestitam!',
      translation: 'Congratulations!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/98554__m__1537483744.mp4',
      phrase: 'Čestitam!',
      translation: 'Congratulations!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/98554__f__1537488988.mp4',
      phrase: 'Čestitam!',
      translation: 'Congratulations!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/98554__m__1537555815.mp4',
      phrase: 'Čestitam!',
      translation: 'Congratulations!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/IAV_LWLQ12025_SL_GREGA_M_271621_65081b55__271621__m_normalized.mp4',
      phrase: 'Čudovito',
      translation: 'Amazing',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/98577__f__1537477795.mp4',
      phrase: 'Super!',
      translation: 'Awesome!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/98577__f__1537481000.mp4',
      phrase: 'Super!',
      translation: 'Awesome!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/98577__f__1537554572_normalized.mp4',
      phrase: 'Super!',
      translation: 'Awesome!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/98577__m__1537490611.mp4',
      phrase: 'Super!',
      translation: 'Awesome!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/98577__m__1537553843.mp4',
      phrase: 'Super!',
      translation: 'Awesome!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/IAV_LWLQ12025_SL_MARTINA_F_98577_17d45650__98577__f_normalized.mp4',
      phrase: 'Super!',
      translation: 'Awesome!',
    },
  ],
  id: [
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/IAV_LWLQ32025_ID_IQI_M_191734_0ceba294__191734__m.mp4',
      phrase: 'Luar biasa!',
      translation: 'Amazing!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/IAV_LWLQ32025_ID_IQI_M_288741_0871699c__288741__m.mp4',
      phrase: 'Mantul!',
      translation: 'Absolutely amazing! (slang)',
    },
  ],
  yo: [
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/20027_YORU_LWL_YO_D_SD2_200930_IMG_8911_080_1_11b6fd30__114845__m.mp4',
      phrase: 'Ẹ kú oríire!',
      translation: 'Congratulations!',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/20027_YORU_LWL_YO_A_SD5_201006_IMG_8057_018_1_fe337f12__114783__f_normalized.mp4',
      phrase: 'Ẹ kúuṣẹ́',
      translation: 'Well done',
    },
    {
      src: 'https://static.memrise.com/uploads/items/videos/medium/20027_YORU_LWL_YO_D_SD2_200930_IMG_8876_018_1_5eb20c2c__114783__m.mp4',
      phrase: 'Ẹ kúuṣẹ́',
      translation: 'Well done',
    },
  ],
};

export const CHECKPOINT_CELEBRATION_LOCALES = Object.keys(CELEBRATION_VIDEOS);

export const LOCALE_ALIASES: Record<string, string> = {
  'es-es': 'es',
  'pt-pt': 'pt',
  nb: 'no',
  nn: 'no',
};

const resolveCelebrationLocale = (locale?: string | null): string | undefined => {
  if (!locale) {
    return undefined;
  }

  const normalized = locale.trim().toLowerCase();
  const aliased = LOCALE_ALIASES[normalized] ?? normalized;
  if (CELEBRATION_VIDEOS[aliased]) {
    return aliased;
  }

  const base = aliased.split('-')[0];
  return CELEBRATION_VIDEOS[base] ? base : undefined;
};

export const getCelebrationVideos = (locale?: string | null): CheckpointCelebrationVideo[] => {
  const resolved = resolveCelebrationLocale(locale);
  return resolved ? CELEBRATION_VIDEOS[resolved] : [];
};

export const getCheckpointCelebrationVideo = (
  locale?: string | null,
): CheckpointCelebrationVideo | undefined => getCelebrationVideos(locale)[0];

export {
  localizeCelebrationTranslation,
  resolveCelebrationUiLocale,
} from './celebrationVideoTranslations';
